import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

/** Actions */
import { showAlert } from '../../../store/ducks/alert';

/** Services */
import { sendNFe } from '../../../services/payment';

const ENotasModal = forwardRef(({ transaction }, ref) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    show() {
      setOpen(true);
    },

    close() {
      setOpen(false);
    },
  }));

  const handleSendNFe = async () => {
    try {
      setIsLoading(true);
      await sendNFe(transaction.ourData.recipientId, transaction.ourData.id);
      dispatch(showAlert('success', 'The NF-e was sent to the owner!'));
      setIsLoading(false);
      setOpen(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! An error ocurred while trying to send the NF-e'));
      console.log(error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">Do you wish to send a NF-e for this transaction?</DialogTitle>
      <DialogContent>
        {!isLoading ? (
          <DialogContentText>
            This action will issue an NF-e for this transaction that will be sent by email to the owner.
          </DialogContentText>
        ) : (
          <DialogContentText style={{ height: 150 }}>
            <CircularProgress color="inherit" className="circular-progress" />
          </DialogContentText>
        )}
      </DialogContent>
      {!isLoading && (
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={handleSendNFe} autoFocus>
            Yes
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
});

export default ENotasModal;
